<template>
  <div class="pa-6">
    <h2>Notifications</h2>
    <v-card v-if="notifications" class="mt-4" elevation="0">
      <v-card-text>
        <div v-for="(item, index) in notifications" :key="index">
          <v-row class="align-center">
            <v-col cols="11">
              <v-card-title
                style="
                  font-size: 16px;
                  line-height: 20px;
                  color: #000;
                  margin-bottom: 10px;
                "
              >
                {{ item.body }}
              </v-card-title>
              <v-card-subtitle> {{formatDate(item.createdAt) }} </v-card-subtitle>
            </v-col>
            <v-col cols="1">
              <v-icon @click="remove(item.id)">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-divider v-if="index !== notifications.length-1"></v-divider>
        </div>
        <div class="text-center">
        <v-pagination
          v-model="tableOptions.page"
          :length="totalPages"
          @input="fetchData"
          circle
        ></v-pagination>
  </div>
      </v-card-text>
    </v-card>
    
    <div v-else>
        <v-card class="my-4" elevation="0">
          <v-card-text>
            <div
              style="height: 80vh"
              class="d-flex flex-column justify-center align-center"
            >
              <img src="/img/Notes.svg" />
              <h4 class="red--text">Notifications not found!</h4>
            </div>
          </v-card-text>
        </v-card>
      </div>
  </div>
</template>

<script>
import LoadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import moment from 'moment'
export default {
  apollo: {
    getNotifications: {
      query: gql`
        query notifications($paginationInput:PaginationInput!) {
          notifications(paginationInput:$paginationInput) {
            rows{
              id
              redirection_url
              module_name
              body
              createdAt
            }
            count
            totalCount
          }
        }
      `,
      variables(){
        return {
          paginationInput:{
            page:this.tableOptions.page,
            limit:this.tableOptions.itemsPerPage
          }
        }
      },
      fetchPolicy: "network-only",
      update:(data)=>data.notifications.rows,
      result({data}){
        const {rows,totalCount}=data.notifications;
        this.notifications=rows;
        this.totalPages=Math.ceil(totalCount / this.tableOptions.itemsPerPage);
        this.stopLoading();
      }
    },
  },
  data(){
    return{
        notifications:[],
        currentPage:1,
        totalPages:0,
        tableOptions: { page: 1, itemsPerPage: 10 },
    }
  },
  
  watch: {
    tableOptions: {
      handler() {
        this.$apollo.queries.getNotifications.refetch();
      },
      deep: true,
    },
  },
  mounted(){
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 2000);
  },
  methods:{
    fetchData(){
      this.startLoading();
      this.$apollo.queries.getNotifications.refetch();
    },
    formatDate(date){
      return moment(date).format('h:mm A, MMMM Do YYYY');
    },
    async remove(id){
        this.startLoading();
        this.$apollo.mutate(
            {
                mutation:gql `
                    mutation($id:Int!){
                        removeNotification(id:$id)
                    }
                `,
                variables:{
                    id:Number(id)
                }
            }
        )
        .then(async()=>{
            this.$notify({
            title: `Notification deleted successfully`,
            text: "",
            type: "success",
          });
          this.$apollo.queries.getNotifications.refetch();
          this.stopLoading();
        })
        .catch(async (error) => {
          console.log(error);
          this.stopLoading();
        });
    }
  },
  mixins: [LoadingMixin],
};
</script>
